import customAxios from './Pages/util/Api';
import authHeader from '../services/auth/jwt/auth-header'; // adjust path to your structure

export const ALLOWED_ROLE_IDS = [1, 4]; // 1 = Admin, 4 = Haulage Admin
const AUTH_VERSION = '2';               // bump to force-logout everyone again
const CHECK_TTL_MS = 60 * 1000;         // how long a successful check is trusted

let lastVerified = { at: 0, ok: false };

export const isRoleAllowed = roleId => ALLOWED_ROLE_IDS.includes(Number(roleId));

const clearSession = () => {
  ['token', 'user'].forEach(k => localStorage.removeItem(k)); // add any other auth keys you persist
  sessionStorage.clear();
  lastVerified = { at: 0, ok: false };
};

export const forceLogout = (reason = 'not_allowed') => {
  clearSession();
  window.location.replace(`/signin?reason=${reason}`); // hard reload resets Redux
};

/**
 * Call ONCE at app boot, BEFORE the redux store is created
 * (so authUser isn't hydrated from a stale localStorage session).
 */
export const invalidateLegacySessions = () => {
  if (localStorage.getItem('authVersion') !== AUTH_VERSION) {
    clearSession();
    localStorage.setItem('authVersion', AUTH_VERSION);
  }
};

/** Returns 'allowed' | 'denied' | 'unauthorized' | 'error' */
export const verifyPortalAccess = async ({ force = false } = {}) => {
  const now = Date.now();
  if (!force && lastVerified.ok && now - lastVerified.at < CHECK_TTL_MS) return 'allowed';

  try {
    const res = await customAxios.get('/User/GetUserProfile', {
      headers: authHeader(),
      params: { _t: now },
    });
    const ok = isRoleAllowed(res?.data?.roleId);
    lastVerified = { at: now, ok };
    return ok ? 'allowed' : 'denied';
  } catch (err) {
    const status = err?.response?.status;
    if (status === 401) return 'unauthorized'; // token expired or invalid
    if (status === 403) return 'denied';
    return 'error';
  }
};